/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SourceAccountAttributesInput } from '../models/SourceAccountAttributesInput';

export class ConnectSourceAccountRequest {
  /**
  * Account display name in Eon.
  */
  'name'?: string;
  'sourceAccountAttributes': SourceAccountAttributesInput;
  /**
  * Whether this is an internal account used by Eon for testing purposes
  */
  'isInternalAccount'?: boolean;
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceAccountAttributes",
      "baseName": "sourceAccountAttributes",
      "type": "SourceAccountAttributesInput",
      "format": ""
    },
    {
      "name": "isInternalAccount",
      "baseName": "isInternalAccount",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectSourceAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

